import { ChangePasswordModel } from './../models/user/changePasswordModel';
import axios from 'axios';
import * as Constants from "../common/constants";
import AuthService from './authService';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { EditProfileModel } from '../models/user/editProfileModel';

class UserService {
  authService = new AuthService();
  axiosInstance = axios.create({
    baseURL: `${Constants.apiUrl}/`,
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${this.authService.getToken()}`,
      Pragma: 'no-cache'
    }
  })

  getUser(id: number) {
    return this.axiosInstance({
      url: `users/getById/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  changePassword(changePasswordModel: ChangePasswordModel) {
    return this.axiosInstance({
      url: `users/changePassword`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(changePasswordModel)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  editProfile(editProfileModel: EditProfileModel) {
    return this.axiosInstance({
      url: `users/editProfile`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(editProfileModel)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default UserService;
